import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  SelectItem,
  FormItem,
  InputNumberItem,
  DatePickerItem,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  ErrorItem
} from "../../../../Components/Items";
import xmlToJson from "../../../../Components/xmlToJson";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";

const { Option } = Select;

moment.locale("es");

class TraspasoEntreCuentas extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    todasBancos: [],
    objetoBancos: [],
    todasProyectos: [],
    objetoProyectos: [],
    monedaOrigen: null,
    monedaDestino: null,
    diferentesMonedas: false,
    archivosXml: [],
    uuid: null,
    xmlId: null,
    xmlData: null,
  };

  componentDidMount() {
    this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasBancos: res.data,
            objetoBancos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + ' - ' + value.banco + (value.moneda?.abreviacion ? ' (' + value.moneda.abreviacion + ')' : '')}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasBancos: this.state.todasBancos?.length > 0
              ? [...this.state.todasBancos, ...res.data]
              : res.data,
            objetoBancos: this.state.objetoBancos?.length > 0
              ? [
                ...this.state.objetoBancos,
                ...res.data.map((value) => (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + (value.banco ? ' - ' + value.banco : '') + (value.moneda?.abreviacion ? ' (' + value.moneda.abreviacion + ')' : '')}
                  </Option>
                )),
              ]
              : res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '') + (value.moneda?.abreviacion ? ' (' + value.moneda.abreviacion + ')' : '')}
                </Option>
              )),
          });
        }
      });
    this.setState({ loading: false });

    // Si se navego desde ArchivosXml con datos XML
    const locationState = this.props.location?.state;
    if (locationState?.fileData) {
      try {
        const parsed = typeof locationState.fileData === 'string'
          ? JSON.parse(locationState.fileData)
          : locationState.fileData;
        this.cargarDatosXml(parsed, locationState.fileName, locationState.xmlId);
      } catch {
        message.error('No se pudo cargar el XML');
      }
    }
  }

  cargarDatosXml(hola, nombreArchivo, xmlId) {
    const comprobante = hola?.attributes;
    const complemento = hola?.children?.find((v) => v.name === 'cfdi:Complemento');
    const timbre = complemento?.children?.find((v) => v.name === 'tfd:TimbreFiscalDigital')?.attributes;
    const divisas = complemento?.children?.find((v) => v.name === 'divisas:Divisas')?.attributes;
    const conceptos = hola?.children?.find((v) => v.name === 'cfdi:Conceptos')?.children || [];

    if (!divisas) {
      message.warning('El XML no contiene complemento de divisas');
      return;
    }

    const concepto = conceptos[0]?.attributes;
    if (!concepto) {
      message.error('No se encontraron conceptos en el XML');
      return;
    }

    // Cantidad = monto en moneda extranjera (ej. 3100 USD)
    // ValorUnitario = tipo de cambio (ej. 17.500335 MXN/USD)
    // Importe = monto en MXN
    const cantidad = Number(concepto.Cantidad);
    const valorUnitario = Number(concepto.ValorUnitario);
    const importe = Number(concepto.Importe);
    const fecha = comprobante?.Fecha ? moment(comprobante.Fecha) : moment();
    const uuid = timbre?.UUID || '';
    const tipoOperacion = divisas.tipoOperacion; // 'compra' o 'venta'

    // tipoOperacion es desde la perspectiva del banco (emisor del CFDI):
    // compra: banco compra ME al cliente → cliente entrega ME y recibe MXN → origen=extranjera, destino=MXN
    // venta:  banco vende ME al cliente → cliente entrega MXN y recibe ME → origen=MXN, destino=extranjera
    let montoOrigen, montoDestino;
    if (tipoOperacion === 'compra') {
      montoOrigen = cantidad;
      montoDestino = importe;
    } else {
      montoOrigen = importe;
      montoDestino = cantidad;
    }

    // Siempre aplicamos los campos que existen en el form sin importar el estado de las cuentas
    this.formRef.current?.setFieldsValue({
      fechaPago: fecha,
      referencia: uuid,
    });

    // En compra: origen=extranjera (tipoCambioOrigen=valorUnitario), destino=MXN (tipoCambioDestino=1)
    // En venta:  origen=MXN (tipoCambioOrigen=1), destino=extranjera (tipoCambioDestino=valorUnitario)
    const xmlData = tipoOperacion === 'compra'
      ? { montoOrigen, montoDestino, tipoCambioOrigen: valorUnitario, tipoCambioDestino: 1 }
      : { montoOrigen, montoDestino, tipoCambioOrigen: 1, tipoCambioDestino: valorUnitario };

    // Si las cuentas ya estan seleccionadas con monedas distintas, aplicamos los montos ahora
    if (this.state.diferentesMonedas) {
      this.formRef.current?.setFieldsValue(xmlData);
    }

    this.setState({
      archivosXml: [{ name: nombreArchivo || (uuid + '.xml'), status: 'success' }],
      uuid,
      xmlId: xmlId || null,
      xmlData,
    });

    if (!this.state.diferentesMonedas) {
      message.info('Selecciona las cuentas origen y destino para que se llenen los montos del XML');
    } else {
      message.success('Se cargaron los datos del XML de divisas');
    }
  }

  esMXN(moneda) {
    return moneda?.abreviacion === 'MXN';
  }

  leerXml(e) {
    if (!e.file.name?.toLowerCase().endsWith('.xml')) {
      return message.error('Solo se permiten archivos XML');
    }
    this.setState({ loading: true });
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const hola = new xmlToJson().parseFromString(event.target.result);
        this.cargarDatosXml(hola, e.file.name);
      } catch {
        message.error('No se pudo leer el archivo XML');
      }
      this.setState({ loading: false });
    };
    reader.readAsText(e.file.originFileObj || e.file);
  }

  onBancoOrigenChange(bancoId) {
    const banco = this.state.todasBancos.find((b) => b._id === bancoId);
    const monedaOrigen = banco?.moneda || null;
    this.setState({ monedaOrigen }, () => {
      if (this.esMXN(monedaOrigen)) {
        this.formRef.current?.setFieldsValue({ tipoCambioOrigen: 1 });
      }
      this.checkDiferentesMonedas();
    });
  }

  onBancoDestinoChange(bancoId) {
    const banco = this.state.todasBancos.find((b) => b._id === bancoId);
    const monedaDestino = banco?.moneda || null;
    this.setState({ monedaDestino }, () => {
      if (this.esMXN(monedaDestino)) {
        this.formRef.current?.setFieldsValue({ tipoCambioDestino: 1 });
      }
      this.checkDiferentesMonedas();
    });
  }

  checkDiferentesMonedas() {
    const { monedaOrigen, monedaDestino, xmlData } = this.state;
    const diferentesMonedas = !!(
      monedaOrigen && monedaDestino &&
      String(monedaOrigen._id) !== String(monedaDestino._id)
    );
    this.setState({ diferentesMonedas }, () => {
      // Cuando se activa el modo distintas monedas, aplicar los datos pendientes del XML (si los hay)
      if (diferentesMonedas && xmlData) {
        this.formRef.current?.setFieldsValue({
          montoOrigen: xmlData.montoOrigen,
          montoDestino: xmlData.montoDestino,
          tipoCambioOrigen: xmlData.tipoCambioOrigen,
          tipoCambioDestino: xmlData.tipoCambioDestino,
        });
        message.success('Se aplicaron los datos del XML de divisas');
        // Una vez aplicados, los limpiamos del state para no re-aplicarlos en cambios futuros
        this.setState({ xmlData: null });
      } else if (diferentesMonedas) {
        // Si es MXN, fijar tipoCambio en 1 al activarse el modo
        const patch = {};
        if (this.esMXN(monedaOrigen)) patch.tipoCambioOrigen = 1;
        if (this.esMXN(monedaDestino)) patch.tipoCambioDestino = 1;
        if (Object.keys(patch).length) this.formRef.current?.setFieldsValue(patch);
      }
    });
    if (!diferentesMonedas) {
      this.formRef.current?.setFieldsValue({
        montoOrigen: undefined,
        montoDestino: undefined,
        tipoCambioOrigen: undefined,
        tipoCambioDestino: undefined,
      });
    }
  }

  onMontoOrigenChange(value) {
    const tcO = this.formRef.current?.getFieldValue('tipoCambioOrigen');
    const tcD = this.formRef.current?.getFieldValue('tipoCambioDestino');
    const montoDestino = this.formRef.current?.getFieldValue('montoDestino');
    const { monedaOrigen, monedaDestino } = this.state;

    // Auto-calc del tipo de cambio faltante cuando uno de los lados es MXN
    if (value && montoDestino) {
      if (this.esMXN(monedaOrigen) && !this.esMXN(monedaDestino)) {
        this.formRef.current?.setFieldsValue({
          tipoCambioDestino: Math.round((value / montoDestino) * 1000000) / 1000000,
        });
        return;
      }
      if (this.esMXN(monedaDestino) && !this.esMXN(monedaOrigen)) {
        this.formRef.current?.setFieldsValue({
          tipoCambioOrigen: Math.round((montoDestino / value) * 1000000) / 1000000,
        });
        return;
      }
    }
    // Ambas extranjeras: si los rates ya estan, recalcular destino
    if (value && tcO && tcD) {
      this.formRef.current?.setFieldsValue({
        montoDestino: Math.round(((value * tcO) / tcD) * 1000000) / 1000000,
      });
    }
  }

  onMontoDestinoChange(value) {
    const tcO = this.formRef.current?.getFieldValue('tipoCambioOrigen');
    const tcD = this.formRef.current?.getFieldValue('tipoCambioDestino');
    const montoOrigen = this.formRef.current?.getFieldValue('montoOrigen');
    const { monedaOrigen, monedaDestino } = this.state;

    // Auto-calc del tipo de cambio faltante cuando uno de los lados es MXN
    if (value && montoOrigen) {
      if (this.esMXN(monedaOrigen) && !this.esMXN(monedaDestino)) {
        this.formRef.current?.setFieldsValue({
          tipoCambioDestino: Math.round((montoOrigen / value) * 1000000) / 1000000,
        });
        return;
      }
      if (this.esMXN(monedaDestino) && !this.esMXN(monedaOrigen)) {
        this.formRef.current?.setFieldsValue({
          tipoCambioOrigen: Math.round((value / montoOrigen) * 1000000) / 1000000,
        });
        return;
      }
    }
    // Ambas extranjeras: si los rates ya estan, recalcular origen
    if (value && tcO && tcD) {
      this.formRef.current?.setFieldsValue({
        montoOrigen: Math.round(((value * tcD) / tcO) * 1000000) / 1000000,
      });
    }
  }

  onTipoCambioOrigenChange(value) {
    const montoOrigen = this.formRef.current?.getFieldValue('montoOrigen');
    const tcD = this.formRef.current?.getFieldValue('tipoCambioDestino');
    if (montoOrigen && value && tcD) {
      this.formRef.current?.setFieldsValue({
        montoDestino: Math.round(((montoOrigen * value) / tcD) * 1000000) / 1000000,
      });
    }
  }

  onTipoCambioDestinoChange(value) {
    const montoOrigen = this.formRef.current?.getFieldValue('montoOrigen');
    const tcO = this.formRef.current?.getFieldValue('tipoCambioOrigen');
    if (montoOrigen && tcO && value) {
      this.formRef.current?.setFieldsValue({
        montoDestino: Math.round(((montoOrigen * tcO) / value) * 1000000) / 1000000,
      });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "traspasoentrecuentas/traspaso",
        {
          ...values,
          empresaId: this.props.empresaId,
          uuid: this.state.uuid || undefined,
          xmlId: this.state.xmlId || undefined,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado una transferencia");
          NotificacionPolizas(res.data.polizasId);
          this.formRef.current.resetFields();
          this.setState({
            monedaOrigen: null,
            monedaDestino: null,
            diferentesMonedas: false,
            archivosXml: [],
            uuid: null,
            xmlId: null,
            xmlData: null,
          });
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo efectuar el traspaso");
        } else {
          message.error("Hubo un error y no se efectuo el traspaso");
        }
      });
  }

  atras() {
    this.props.history.goBack();
  }

  render() {
    const { monedaOrigen, monedaDestino, diferentesMonedas } = this.state;
    const labelOrigen = monedaOrigen
      ? `Monto Origen (${monedaOrigen.abreviacion})`
      : 'Monto Origen';
    const labelDestino = monedaDestino
      ? `Monto Destino (${monedaDestino.abreviacion})`
      : 'Monto Destino';

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Traspaso entre Cuentas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={this.state.archivosXml}
              customRequest={this.leerXml.bind(this)}
              accept=".xml"
            >
              <ButtonItem type="primary" icon={<UploadOutlined />}>
                Cargar XML de Divisas
              </ButtonItem>
            </Upload>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="traspasoEntreCuentas"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Traspasar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              {/* Datos generales */}
              <Row gutter={16}>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem
                    label="Fecha de Pago"
                    name="fechaPago"
                    required
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Pago"
                      allowClear={false}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem label="Proyecto" name="proyectoId" required>
                    <SelectItem placeholder="Proyecto">
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem name="referencia" label="Referencia" pattern>
                    <InputItem placeholder="Referencia" />
                  </FormItem>
                </Col>
              </Row>

              {/* Cuentas */}
              <Row gutter={16}>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem label="Cuenta Origen" name="bancoOrigenId" required>
                    <SelectItem
                      placeholder="Cuenta Origen"
                      onChange={this.onBancoOrigenChange.bind(this)}
                    >
                      {this.state.objetoBancos}
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem label="Cuenta Destino" name="bancoDestinoId" required>
                    <SelectItem
                      placeholder="Cuenta Destino"
                      onChange={this.onBancoDestinoChange.bind(this)}
                    >
                      {this.state.objetoBancos}
                    </SelectItem>
                  </FormItem>
                </Col>
              </Row>

              {/* Montos */}
              {diferentesMonedas ? (
                <>
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <FormItem required number label={labelOrigen} name="montoOrigen" type="number">
                        <InputNumberItem
                          dinero
                          placeholder={labelOrigen}
                          onChange={this.onMontoOrigenChange.bind(this)}
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <FormItem required number label={labelDestino} name="montoDestino" type="number">
                        <InputNumberItem
                          dinero
                          placeholder={labelDestino}
                          onChange={this.onMontoDestinoChange.bind(this)}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <FormItem
                        required
                        number
                        label={`Tipo de Cambio${monedaOrigen ? ' (' + monedaOrigen.abreviacion + ')' : ' Origen'}`}
                        name="tipoCambioOrigen"
                        initialValue={this.esMXN(monedaOrigen) ? 1 : undefined}
                      >
                        <InputNumberItem
                          placeholder="Tipo de Cambio Origen"
                          disabled={this.esMXN(monedaOrigen)}
                          onChange={this.onTipoCambioOrigenChange.bind(this)}
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <FormItem
                        required
                        number
                        label={`Tipo de Cambio${monedaDestino ? ' (' + monedaDestino.abreviacion + ')' : ' Destino'}`}
                        name="tipoCambioDestino"
                        initialValue={this.esMXN(monedaDestino) ? 1 : undefined}
                      >
                        <InputNumberItem
                          placeholder="Tipo de Cambio Destino"
                          disabled={this.esMXN(monedaDestino)}
                          onChange={this.onTipoCambioDestinoChange.bind(this)}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row gutter={16} justify="center">
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem required number margin label="Monto" name="monto" type="number">
                      <InputNumberItem dinero placeholder="Monto" />
                    </FormItem>
                  </Col>
                </Row>
              )}
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(TraspasoEntreCuentas);
